module.exports = __webpack_public_path__ + "img/cashlessfyi-logo-512.a53ba744.png";